import React, { useState, useEffect } from 'react';
import logo from './img/logo_no_bg.png';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './mobilenav.css';

const NAV = [
    { label: 'About Us', href: '/about_us/who_we_are' },
    {
        label: 'Technology',
        children: [
            { name: 'HydroVerra', href: '/ourtechnology/HydroVerra' },
            { name: 'HydraCell',  href: '/ourtechnology/HydraCell' },
            { name: 'Zyraxon',    href: '/ourtechnology/Zyraxon' },
        ],
    },
    {
        label: 'Sectors',
        children: [
            { name: 'All Sectors',             href: '/sectors' },
            { name: 'EV Charging & Transport', href: '/sectors/ev-charging' },
            { name: 'Events & Festivals',      href: '/sectors/events' },
            { name: 'Rural & Remote',          href: '/sectors/rural-remote' },
            { name: 'Ports, Marine & Vessels', href: '/sectors/ports-maritime' },
            { name: 'Emergency & Resilience',  href: '/sectors/emergency' },
            { name: 'Construction Sites',            href: '/sectors/construction' },
            { name: 'Public Sector',           href: '/sectors/public-sector' },
            { name: 'Film & Production',       href: '/sectors/film-production' },
        ],
    },
    { label: 'Impact',    href: '/impact' },
    { label: 'News',      href: '/news' },
    { label: 'Careers',   href: '/careers' },
];

function CustomMobileNav() {
    const [open, setOpen] = useState(false);
    const [expanded, setExpanded] = useState(null);

    const close = () => { setOpen(false); setExpanded(null); };

    useEffect(() => {
        const onKey = (e) => { if (e.key === 'Escape') close(); };
        document.addEventListener('keydown', onKey);
        document.body.classList.toggle('no-scroll', open);
        return () => {
            document.removeEventListener('keydown', onKey);
            document.body.classList.remove('no-scroll');
        };
    }, [open]);

    const toggle = (label) =>
        setExpanded(prev => (prev === label ? null : label));

    return (
        <>
            {/* ── Top bar ── */}
            <header className="mob-topbar">
                <a href="/" className="mob-topbar__brand">
                    <img src={logo} alt="OctoNexus Power" className="mob-topbar__logo" />
                    <span className="mob-topbar__name">Octo<span style={{ color: '#0fa19a' }}>Nexus</span><span className="mob-topbar__sub"> Power</span></span>
                </a>
                <button
                    className="mob-topbar__burger"
                    onClick={() => setOpen(true)}
                    aria-label="Open mobile navigation menu"
                    aria-expanded={open}
                >
                    <i className="bi bi-list" />
                </button>
            </header>

            {/* ── Backdrop ── */}
            {open && <div className="mob-backdrop" onClick={close} aria-hidden="true" />}

            {/* ── Drawer ── */}
            <nav className={`mob-drawer ${open ? 'mob-drawer--open' : ''}`} aria-label="Mobile navigation">

                {/* Drawer header */}
                <div className="mob-drawer__head">
                    <a href="/" className="mob-drawer__brand" onClick={close}>
                        <img src={logo} alt="OctoNexus Power" className="mob-drawer__logo" />
                        <span className="mob-drawer__name">OctoNexus Power</span>
                    </a>
                    <button className="mob-drawer__close" onClick={close} aria-label="Close navigation">
                        <i className="bi bi-x-lg" />
                    </button>
                </div>

                {/* Links */}
                <ul className="mob-nav">
                    {NAV.map((item) =>
                        item.children ? (
                            <li key={item.label} className="mob-nav__item">
                                <button
                                    className={`mob-nav__group ${expanded === item.label ? 'mob-nav__group--open' : ''}`}
                                    onClick={() => toggle(item.label)}
                                >
                                    {item.label}
                                    <i className={`bi ${expanded === item.label ? 'bi-chevron-up' : 'bi-chevron-down'} mob-nav__chevron`} />
                                </button>
                                {expanded === item.label && (
                                    <ul className="mob-nav__sub">
                                        {item.children.map((c) => (
                                            <li key={c.href}>
                                                <a href={c.href} className="mob-nav__sublink" onClick={close}>
                                                    {c.name}
                                                </a>
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </li>
                        ) : (
                            <li key={item.label} className="mob-nav__item">
                                <a href={item.href} className="mob-nav__link" onClick={close}>
                                    {item.label}
                                </a>
                            </li>
                        )
                    )}
                </ul>

                {/* CTA */}
                <div className="mob-drawer__footer">
                    <a href="/contactus" className="mob-drawer__cta" onClick={close}>
                        Get in Touch <i className="bi bi-arrow-right" />
                    </a>
                </div>

            </nav>
        </>
    );
}

export default CustomMobileNav;
